import { MessageSquare, Layers, Code2, Rocket, ArrowRight } from 'lucide-react';

const STEPS = [
  { icon: MessageSquare, number: '01', title: 'Discovery Call', duration: 'Day 1',
    description: 'We learn your business, goals, and technical requirements. You get a clear scope, timeline, and fixed-price quote within 24 hours.' },
  { icon: Layers, number: '02', title: 'Architecture & Design', duration: 'Days 2–4',
    description: 'System architecture, wireframes, and a design prototype you can click through. Nothing gets built until you approve the plan.' },
  { icon: Code2, number: '03', title: 'Build & Iterate', duration: 'Weeks 1–3',
    description: 'Rapid development in weekly sprints. You get a staging link from day one and review progress in real-time. No surprises.' },
  { icon: Rocket, number: '04', title: 'Launch & Support', duration: 'Ongoing',
    description: "Deployment, monitoring, and 30 days of post-launch support included. We don't disappear after handoff." },
];

const Process = () => (
  <section className="r-section process" id="process">
    <div className="r-wrap">
      <div className="r-tag r-reveal">Process</div>
      <h2 className="r-head r-reveal">
        From idea to launch <span className="r-gtxt">in weeks, not months.</span>
      </h2>
      <p className="r-sub r-reveal r-d1">
        A proven 4-step process that keeps you in control while we move at speed.
        Fixed pricing. No scope creep. Weekly updates.
      </p>

      <div className="proc-grid">
        {STEPS.map((step, i) => {
          const Icon = step.icon;
          return (
            <div key={step.number} className={`proc-card r-reveal r-d${(i % 6) + 1}`}>
              <div className="proc-step">STEP {step.number}</div>
              <div className="proc-icon"><Icon className="w-5 h-5" /></div>
              <h3 className="proc-h">{step.title}</h3>
              <div className="proc-dur">{step.duration}</div>
              <p className="proc-p">{step.description}</p>
            </div>
          );
        })}
      </div>

      <div className="proc-cta r-reveal">
        <a href="#contact" className="btn-primary fh-cta">
          <span>Start your project today</span>
          <ArrowRight className="w-4 h-4" />
        </a>
        <div className="proc-cta-note">Free discovery call · Fixed pricing · No commitment</div>
      </div>
    </div>
  </section>
);

export default Process;
